import App from "@/views/App.vue";

export default [
  {
    path: "/exclusive-club",
    name: "exclusiveClub",
    component: App,
    redirect: { name: "exclusiveClubHome" },
    children: [
      {
        path: "",
        name: "exclusiveClubHome",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ExclusiveClub.vue"),
        meta: {
          displayName: "Exclusive Club - Exclusive Lounge",
          requiresAuth: true,
        },
      },
      {
        path: "/exclusive-club/sobre",
        name: "exclusiveClubAbout",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/AboutExclusiveClub.vue"
          ),
        meta: {
          displayName: "Entenda seus pontos - Exclusive Lounge",
          requiresAuth: true,
        },
      },
    ],
  },
];
